module.exports = __webpack_public_path__ + "static/media/ai-ad-ossoff-thumbnailMOBILE.b3465248.jpg";